export let UserPassedActions = /*#__PURE__*/function (UserPassedActions) {
  UserPassedActions["inventoryTermAccepted"] = "inventoryTermAccepted";
  UserPassedActions["demoInventoryTourShown"] = "demoInventoryTourShown";
  UserPassedActions["creditsInfoShown"] = "creditsInfoShown";
  return UserPassedActions;
}({});
export const DefaultUserPassedActionsObject = {
  [UserPassedActions.inventoryTermAccepted]: null,
  [UserPassedActions.demoInventoryTourShown]: false,
  [UserPassedActions.creditsInfoShown]: false
};